import { BodyContainer } from './components/body/body.mjs';
import { EventItemContainer } from './components/body/item.mjs';
import { useCalendarContext, CalendarContextProvider } from './components/context/calendarProvider.mjs';
import { useCalendarEventContext, CalendarEventContext, CalendarEventProvider } from './components/context/eventProvider.mjs';
import { DayAndWeekIndicator } from './components/indicator/DayAndWeek/index.mjs';
import { DateItem } from './components/indicator/DayAndWeek/DateItem.mjs';
import { Header } from './components/indicator/header/index.mjs';
import { getLocalYYYYMMDD, getLocalHHMMperiod } from './utils.mjs';

var CalendarBlock = {
  Header: Header,
  BodyContainer: BodyContainer,
  DayAndWeekIndicator: DayAndWeekIndicator,
  DateItem: DateItem,
  EventItemContainer: EventItemContainer,
  Contexts: {
    Calender: {
      useCalendarContext: useCalendarContext,
      CalendarContextProvider: CalendarContextProvider
    },
    Event: {
      useCalendarEventContext: useCalendarEventContext,
      CalendarEventContext: CalendarEventContext,
      CalendarEventProvider: CalendarEventProvider
    }
  },
  utils: {
    getLocalYYYYMMDD: getLocalYYYYMMDD,
    getLocalHHMMperiod: getLocalHHMMperiod
  }
};

export { CalendarBlock as default };
